import { Observable } from 'rxjs';
import { IDeleteGateway, IGetGateway, ISaveGateway } from '../gateways';
import {
  IOperatorMapping,
  OPERATOR_MAPPINGS_SCHEMA,
  OperatorMappingId,
} from '@web/dtos';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';

export class OperatorMappingGateway
  implements
    IGetGateway<null, IApiResponse<IOperatorMapping[]> | null>,
    IDeleteGateway<OperatorMappingId, IApiResponse<IOperatorMapping[]> | null>,
    ISaveGateway<IOperatorMapping[], IApiResponse<IOperatorMapping[]> | null>
{
  private readonly restCallBuilder: RestCallBuilder<IOperatorMapping[]> =
    new RestCallBuilder<IOperatorMapping[]>([]);

  get(): Observable<IApiResponse<IOperatorMapping[]>> {
    return this.restCallBuilder
      .get('/operator-mapping/')
      .validate(
        API_RESPONSE_SCHEMA(OPERATOR_MAPPINGS_SCHEMA),
        'OperatorMapping.get'
      )
      .handleMessages()
      .build();
  }

  save(
    query: IOperatorMapping[]
  ): Observable<IApiResponse<IOperatorMapping[]>> {
    return this.restCallBuilder
      .post('/operator-mapping/', query)
      .validate(
        API_RESPONSE_SCHEMA(OPERATOR_MAPPINGS_SCHEMA),
        'OperatorMapping.save'
      )
      .handleMessages()
      .build();
  }

  delete(
    query: OperatorMappingId
  ): Observable<IApiResponse<IOperatorMapping[]>> {
    return this.restCallBuilder
      .delete(`/operator-mapping?mappingId=${query}`)
      .validate(
        API_RESPONSE_SCHEMA(OPERATOR_MAPPINGS_SCHEMA),
        'OperatorMapping.delete'
      )
      .handleMessages()
      .build();
  }
}
